import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../api/client";
import { GENDER_BG_COLORS } from "../../pages/AdminDashboard";

const TabUser = ({}) => {
  const [pending, setPending] = useState([]);
  const [userTab, setUserTab] = useState("pending");
  const [credEditId, setCredEditId] = useState(null);
  const [credForm, setCredForm] = useState({ newPassword: "" });
  const [allUsers, setAllUsers] = useState([]);
  const [stops, setStops] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [bulkSelectedUsers, setBulkSelectedUsers] = useState([]);
  const [credSearchTerm, setCredSearchTerm] = useState("");
  const [filteredCredUsers, setFilteredCredUsers] = useState([]);

  const load = async () => {
    const r = await api("/admin/registrations");
    setPending(r.users);
    const all = await api("/admin/users/all");
    const sortedUsers = all.users.sort((a, b) => {
      if (a.role === "passenger" && b.role !== "passenger") return -1;
      if (a.role !== "passenger" && b.role === "passenger") return 1;
      return a.name.localeCompare(b.name);
    });
    setAllUsers(sortedUsers);
    setFilteredUsers(sortedUsers);
    setFilteredCredUsers(sortedUsers);
    const rs = await api("/admin/stops");
    setStops(rs.stops);
  };
  
  const updateUserInList = (updatedUser) => {
    const updateList = (users) => {
      return users.map(u => u._id === updatedUser._id ? updatedUser : u);
    };
    setAllUsers(updateList(allUsers));
    setFilteredUsers(updateList(filteredUsers));
    setFilteredCredUsers(updateList(filteredCredUsers));
  };
  useEffect(() => {
    load();
  }, []);

  const approve = async (id) => {
    await api(`/admin/registrations/${id}/approve`, { method: "POST" });
    load();
  };
  const reject = async (id) => {
    await api(`/admin/registrations/${id}/reject`, { method: "POST" });
    load();
  };
  const del = async (id) => {
    const name = allUsers.find((u) => u._id === id)?.name || "this user";
    if (window.confirm(`Delete ${name}?`)) {
      await api(`/admin/registrations/${id}`, { method: "DELETE" });
      load();
    }
  };

  const bulkDeleteUsers = async () => {
    if (bulkSelectedUsers.length === 0) {
      alert("No users selected");
      return;
    }
    if (window.confirm(`Delete ${bulkSelectedUsers.length} user(s)?`)) {
      try {
        await api("/admin/registrations/bulk-delete", {
          method: "POST",
          body: { userIds: bulkSelectedUsers },
        });
        setBulkSelectedUsers([]);
        load();
      } catch (err) {
        alert(err.message || "Failed to delete users");
      }
    }
  };

  const toggleUserSelection = (userId) => {
    setBulkSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const toggleSelectAll = () => {
    const currentPageUsers = filteredUsers
      .filter((u) => u.status !== "pending")
      .slice((page - 1) * itemsPerPage, page * itemsPerPage)
      .map((u) => u._id);
    
    const allSelected = currentPageUsers.every((id) =>
      bulkSelectedUsers.includes(id)
    );

    if (allSelected) {
      setBulkSelectedUsers((prev) =>
        prev.filter((id) => !currentPageUsers.includes(id))
      );
    } else {
      setBulkSelectedUsers((prev) => [
        ...prev,
        ...currentPageUsers.filter((id) => !prev.includes(id)),
      ]);
    }
  };

  return (
    <div className="card">
      <h3>User Management</h3>
      <div className="nested-tabs">
        <button
          className={`user-tab-btn${userTab === "pending" ? " active" : ""}`}
          onClick={async () => {
            setUserTab("pending");
            const r = await api("/admin/registrations");
            setPending(r.users);
          }}
        >
          Pending Users
        </button>
        <button
          className={`user-tab-btn${userTab === "all" ? " active" : ""}`}
          onClick={async () => {
            setUserTab("all");
            const all = await api("/admin/users/all");
            setAllUsers(all.users);
            setFilteredUsers(all.users);
          }}
        >
          Current Users
        </button>
        <button
          className={`user-tab-btn${
            userTab === "credentials" ? " active" : ""
          }`}
          onClick={async () => {
            setUserTab("credentials");
            const all = await api("/admin/users/all");
            setAllUsers(all.users);
          }}
        >
          Passwords
        </button>
      </div>
      {userTab === "credentials" ? (
        <div className="scroll-x">
          <div style={{ marginBottom: "1rem" }}>
            <input
              type="text"
              placeholder="Search by name..."
              value={credSearchTerm}
              onChange={(e) => {
                const term = e.target.value.toLowerCase();
                setCredSearchTerm(term);
                if (term.trim() === "") {
                  setFilteredCredUsers(allUsers);
                } else {
                  const filtered = allUsers.filter((u) =>
                    u.name.toLowerCase().includes(term)
                  );
                  setFilteredCredUsers(filtered);
                }
              }}
              style={{
                width: "100%",
                maxWidth: "400px",
                padding: "0.5rem",
                fontSize: "0.875rem",
                border: "1px solid #d1d5db",
                borderRadius: "4px",
              }}
            />
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>New Password</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCredUsers
                .filter((u) => u.status === "approved")
                .map((u) => (
                  <tr key={u._id}>
                    <td>{u.name}</td>
                    <td>{u.email}</td>
                    <td>{u.contact || "-"}</td>
                    <td>
                      <input
                        type="password"
                        value={credEditId === u._id ? credForm.newPassword : ""}
                        disabled={credEditId !== u._id}
                        onChange={(e) =>
                          setCredForm({ newPassword: e.target.value })
                        }
                        placeholder="Enter new password"
                      />
                    </td>
                    <td>
                      {credEditId === u._id ? (
                        <>
                          <button
                            className="btn success"
                            style={{
                              fontSize: ".8rem",
                              padding: ".35rem .7rem",
                            }}
                            onClick={async () => {
                              if (
                                !credForm.newPassword ||
                                credForm.newPassword.length < 6
                              ) {
                                alert("Password must be at least 6 characters");
                                return;
                              }
                              try {
                                await api(
                                  `/admin/users/${u._id}/update-password`,
                                  {
                                    method: "POST",
                                    body: {
                                      newPassword: credForm.newPassword,
                                    },
                                  }
                                );
                                alert("Password updated");
                                setCredEditId(null);
                                setCredForm({ newPassword: "" });
                              } catch (e) {
                                const msg = e.message?.includes("Too many")
                                  ? "For system security, you can change passwords a limited number of times within a short period. Please try again later."
                                  : e.message;
                                alert(msg);
                              }
                            }}
                          >
                            Save
                          </button>
                          <button
                            className="btn secondary"
                            style={{
                              fontSize: ".8rem",
                              padding: ".35rem .7rem",
                            }}
                            onClick={() => {
                              setCredEditId(null);
                              setCredForm({ newPassword: "" });
                            }}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn"
                          style={{
                            fontSize: ".8rem",
                            padding: ".35rem .7rem",
                          }}
                          onClick={() => {
                            setCredEditId(u._id);
                            setCredForm({ newPassword: "" });
                          }}
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              {filteredCredUsers.filter((u) => u.status === "approved").length === 0 && (
                <tr>
                  <td colSpan={7}>No users</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : userTab === "pending" ? (
        <div className="scroll-x">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Contact</th>
                <th>Stop</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pending.map((u) => (
                <UserRow
                  key={u._id}
                  user={u}
                  onApprove={approve}
                  onReject={reject}
                  onDelete={del}
                  type="pending"
                  stops={stops}
                />
              ))}
              {pending.length === 0 && (
                <tr>
                  <td colSpan={6}>No pending user registration requests</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          <div style={{ marginBottom: "1rem" }}>
            <input
              type="text"
              placeholder="Search by name..."
              value={searchTerm}
              onChange={(e) => {
                const term = e.target.value.toLowerCase();
                setSearchTerm(term);
                setPage(1);
                if (term.trim() === "") {
                  setFilteredUsers(allUsers);
                } else {
                  const filtered = allUsers.filter((u) =>
                    u.name.toLowerCase().includes(term)
                  );
                  filtered.sort((a, b) => {
                    if (a.role === "passenger" && b.role !== "passenger") return -1;
                    if (a.role !== "passenger" && b.role === "passenger") return 1;
                    return a.name.localeCompare(b.name);
                  });
                  setFilteredUsers(filtered);
                }
              }}
              style={{
                width: "100%",
                maxWidth: "400px",
                padding: "0.5rem",
                fontSize: "0.875rem",
                border: "1px solid #d1d5db",
                borderRadius: "4px",
              }}
            />
          </div>

          {bulkSelectedUsers.length > 0 && (
            <div style={{ marginBottom: "1rem", display: "flex", gap: "1rem", alignItems: "center" }}>
              <span style={{ fontWeight: 600, color: "#2d7a64" }}>
                {bulkSelectedUsers.length} selected
              </span>
              <button
                className="btn danger"
                onClick={bulkDeleteUsers}
              >
                Delete Selected
              </button>
              <button
                className="btn secondary"
                onClick={() => setBulkSelectedUsers([])}
              >
                Clear Selection
              </button>
            </div>
          )}

          <div style={{ marginBottom: "1rem", display: "flex", gap: "1rem", alignItems: "center" }}>
            <button
              className="btn"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Prev
            </button>
            <span>
              Page {page} of {Math.ceil(filteredUsers.filter((u) => u.status !== "pending").length / itemsPerPage) || 1}
            </span>
            <button
              className="btn"
              disabled={page >= Math.ceil(filteredUsers.filter((u) => u.status !== "pending").length / itemsPerPage)}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
            <select 
              value={itemsPerPage} 
              onChange={(e) => {
                setItemsPerPage(parseInt(e.target.value));
                setPage(1);
              }}
              className="tms-select"
            >
              {[20, 50, 100].map((num) => (
                <option key={num} value={num}>{num} per page</option>
              ))}
            </select>
          </div>

          <div className="scroll-x">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: "50px" }}>
                    <input
                      type="checkbox"
                      checked={
                        filteredUsers
                          .filter((u) => u.status !== "pending")
                          .slice((page - 1) * itemsPerPage, page * itemsPerPage)
                          .length > 0 &&
                        filteredUsers
                          .filter((u) => u.status !== "pending")
                          .slice((page - 1) * itemsPerPage, page * itemsPerPage)
                          .every((u) => bulkSelectedUsers.includes(u._id))
                      }
                      onChange={toggleSelectAll}
                      style={{ cursor: "pointer" }}
                    />
                  </th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Contact</th>
                  <th>Stop</th>
                  <th>Gender</th>
                  {bulkSelectedUsers.length === 0 && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {filteredUsers
                  .filter((u) => u.status !== "pending")
                  .slice((page - 1) * itemsPerPage, page * itemsPerPage)
                  .map((u) => (
                    <UserRow
                      key={u._id}
                      user={u}
                      onApprove={approve}
                      onReject={reject}
                      onDelete={del}
                      type="all"
                      stops={stops}
                      isSelected={bulkSelectedUsers.includes(u._id)}
                      onToggleSelect={toggleUserSelection}
                      hasBulkSelection={bulkSelectedUsers.length > 0}
                      onUserUpdated={updateUserInList}
                    />
                  ))}
                {filteredUsers.filter((u) => u.status !== "pending").length === 0 && (
                  <tr>
                    <td colSpan={8}>None</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

function UserRow({ user, onApprove, onReject, onDelete, type, stops, isSelected, onToggleSelect, hasBulkSelection, onUserUpdated }) {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({
    name: user.name,
    email: user.email,
    contact: user.contact || "",
    stop: user.stop?._id || user.stop || "",
    gender: user.gender || "male",
  });
  const save = async () => {
    if (!form.name || !form.email || !form.contact || !form.stop) {
      alert("All fields are required");
      return;
    }
    try {
      const response = await api(`/admin/registrations/${user._id}/edit`, {
        method: "POST",
        body: form,
      });
      setEdit(false);
      if (response.user && onUserUpdated) {
        onUserUpdated(response.user);
      }
    } catch (err) {
      alert(err.message || "Failed to update user");
    }
  };

  const nameBgColor = GENDER_BG_COLORS[user.gender] || "transparent";

  return (
    <tr>
      {type === "all" && (
        <td>
          <input
            type="checkbox"
            checked={isSelected || false}
            onChange={() => onToggleSelect(user._id)}
            style={{ cursor: "pointer" }}
          />
        </td>
      )}
      <td style={{ backgroundColor: nameBgColor }}>
        {edit ? (
          <input
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            style={{ width: "90px" }}
            required
          />
        ) : (
          user.name
        )}
      </td>
      <td>
        {edit ? (
          <input
            value={form.email}
            type="email"
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            style={{ width: "140px" }}
            required
          />
        ) : (
          user.email
        )}
      </td>
      <td>{user.role}</td>
      <td>
        {edit ? (
          <input
            value={form.contact}
            onChange={(e) =>
              setForm((f) => ({ ...f, contact: e.target.value }))
            }
            style={{ width: "90px" }}
            required
          />
        ) : (
          user.contact || "-"
        )}
      </td>
      <td>
        {edit ? (
          <select
            value={form.stop}
            onChange={(e) => setForm((f) => ({ ...f, stop: e.target.value }))}
            style={{ width: "120px" }}
            required
          >
            <option value="">Select Stop</option>
            {stops &&
              stops.map((stop) => (
                <option key={stop._id} value={stop._id}>
                  {stop.name}
                </option>
              ))}
          </select>
        ) : (
          user.stop?.name || user.stop || "-"
        )}
      </td>
      {type === "all" && (
        <td>
          {edit ? (
            <select
              value={form.gender}
              onChange={(e) =>
                setForm((f) => ({ ...f, gender: e.target.value }))
              }
              required
            >
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          ) : user.gender ? (
            user.gender.charAt(0).toUpperCase() + user.gender.slice(1)
          ) : (
            "-"
          )}
        </td>
      )}
      {!hasBulkSelection && (
        <td>
          <span style={{ display: "flex", gap: "0.4rem", flexWrap: "wrap" }}>
            {edit ? (
              <>
                <button
                  className="btn success"
                  style={{ fontSize: "0.8rem", padding: "0.3rem 0.7rem" }}
                  onClick={save}
                >
                  Save
                </button>
                <button
                  className="btn secondary"
                  style={{ fontSize: "0.8rem", padding: "0.3rem 0.7rem" }}
                  onClick={() => setEdit(false)}
                >
                  Cancel
                </button>
              </>
            ) : (
              <>
                {type === "all" && (
                  <button
                    className="btn"
                    style={{ fontSize: "0.8rem", padding: "0.3rem 0.7rem" }}
                    onClick={() => setEdit(true)}
                  >
                    Edit
                  </button>
                )}
                {type === "all" && (
                  <button
                    className="btn danger"
                    style={{ fontSize: "0.8rem", padding: "0.3rem 0.7rem" }}
                    onClick={() => onDelete(user._id)}
                  >
                    Delete
                  </button>
                )}
                {type === "pending" && (
                  <button
                    className="btn success"
                    style={{ fontSize: "0.8rem", padding: "0.3rem 0.7rem" }}
                    onClick={() => onApprove(user._id)}
                  >
                    Approve
                  </button>
                )}
                {type === "pending" && (
                  <button
                    className="btn warn"
                    style={{ fontSize: "0.8rem", padding: "0.3rem 0.7rem" }}
                    onClick={() => onReject(user._id)}
                  >
                    Reject
                  </button>
                )}
              </>
            )}
          </span>
        </td>
      )}
    </tr>
  );
}

export default TabUser;
